import { GoogleMap, Marker, useJsApiLoader, LoadScriptNext, useLoadScript } from '@react-google-maps/api'
import { useState, useCallback } from 'react'
import { WafFriendlyPass } from 'src/types/waf-friendly-pass'
import styles from './style.module.scss'

type Props = {
  lat: WafFriendlyPass.googleMapLat
  lng: WafFriendlyPass.googleMapLng
  name: string
}

const key = process.env.NEXT_PUBLIC_APP_ENV === 'staging' ? 'AIzaSyDGpAuH6ic4FqE92AlylUXQWgPc-8ZVvzA' : 'AIzaSyCeTdov3Egcf_S9fI1ZU3JMKxCc253ja-4'

const Map: React.VFC<Props> = ({ lat, lng, name }) => {
  const [pos, setPos] = useState({ lat: lat, lng: lng })
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: key
  })

  const [map, setMap] = useState(null)

  const onLoad = useCallback(function callback(map) {
    setMap(map)
    setPos({ lat: lat, lng: lng })
  }, [])

  const onUnmount = useCallback(function callback(map) {
    setMap(null)
    setPos({ lat: 0, lng: 0 })
  }, [])

  return isLoaded ? (
    <div className={styles.googleMap}>
      <GoogleMap
        center={{ lat: lat, lng: lng }}
        zoom={18}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        <Marker title={name} position={{ lat: lat, lng: lng }} />
      </GoogleMap>
    </div>
  ) : <></>
}

export { Map }
